import { render, staticRenderFns } from "./CustomerOrderMode.vue?vue&type=template&id=723407e9&scoped=true&"
import script from "./CustomerOrderMode.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723407e9",
  null
  
)

export default component.exports